import React, { forwardRef } from "react";
import IconUser from "../../assets/images/icon-user.png";
import { styleContainerLogin, styleIconLogin } from "../../assets/classnames";

export const UserLoginIcon = forwardRef((props, ref) => (
  <div
    ref={ref}
    className={styleContainerLogin}
    {...props}
  >
    <img className={styleIconLogin} src={IconUser} alt="User Icon" />
    <span className="text-white pr-0.5">Login</span>
  </div>
));

UserLoginIcon.displayName = "UserLoginIcon";
